export default "__VITE_ASSET__ef9d206e__"